import { CreateUser, User } from "./types";

export const redirectToCasLogin = (casServer: string, service: string) => {
  const loginUrl = `${casServer}/login?service=${encodeURIComponent(service)}`;
  window.location.href = loginUrl;
};

export const validateTicket = async (
  casServer: string,
  service: string,
  ticket: string
): Promise<User | null> => {
  const validateUrl = `${casServer}/serviceValidate?service=${encodeURIComponent(
    service
  )}&ticket=${ticket}`;
  const response = await fetch(validateUrl);
  if (response.ok) {
    const data = await response.text();
    const usuario = parseCasResponse(data);
    if (usuario) {
       return CreateUser(usuario);
    }
  }
  return null;
};

const parseCasResponse = (xmlString: string): string | null => {
  // Crear un parser para analizar el XML
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  // Verificar si hubo errores en el parseo
  const parseError = xmlDoc.querySelector("parsererror");
  if (parseError) {
    console.error("Error al parsear la respuesta XML:", parseError.textContent);
    return null;
  }

  // Buscar el nodo <cas:user>
  const userNode = xmlDoc.getElementsByTagName("cas:user")[0];
  if (userNode) {
    return userNode.textContent; // Extraer el contenido del nodo
  }

  console.warn("No se encontró el nodo <cas:user> en la respuesta.");
  return null;
};
